<template>
  <svg class="hamburger-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><g fill-rule="evenodd" stroke="currentColor" :class="hamburgerClass" stroke-width="2"><path d="M1 16h17M1 9.5h17M1 3h17" /></g></svg>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    color: {
      type: String,
      default: 'dark',
    },
  },
  computed: {
    hamburgerClass() {
      return {
        'text-dark': this.color === 'dark',
        'text-light': this.color === 'light',
      };
    },
  },
};

</script>

<style lang="scss" scopped>
  .hamburger-icon {
    display: block;
    width: 19px;
    height: 19px;
  }
</style>
